import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { ListDisplayStudentModule } from '../../list-display/list-display-student/list-display-student.module';
import { ListSearchModule } from '../../list-search/list-search.module';
import { SharedServicesModule } from './../../../../shared/services/shared.services.module';
import { AttendanceMadLib } from './attendance-mad-lib.component';

@NgModule({
  declarations: [AttendanceMadLib],
  imports: [
    SharedServicesModule,
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatMenuModule,
    FormsModule,
    MatGridListModule,
    ListDisplayStudentModule,
    ListSearchModule,
  ],
  exports: [AttendanceMadLib],
  providers: [],
})
export class AttendanceMadLibModule {
  /** */
}
